import apiClient, { ApiDefinition } from '@documentsApi';

type ThisApi = ApiDefinition['/archives']['POST'];
type Input = ThisApi['body'];
type Output = ThisApi['response'];

const createArchive = async ({ name, files }: Input): Promise<Output> => {
  const response = await apiClient.post('/archives', {
    files,
    name,
  });

  return response.data;
};

export default createArchive;
